"use strict";
import AudioParams from "./AudioParams";

export default class AudioManager {
    constructor() {
        /**
         * @type {object}
         * @private
         */
        this._cache = {};

        /**
         * @type {Howl}
         * @private
         */
        this._music = null;

        /**
         * @type {boolean}
         * @private
         */
        this._isMuted = false;

        /**
         *
         * @type {boolean}
         * @private
         */
        this._isMute = false;

        var hidden;
        "undefined" != typeof document.hidden ? (hidden = "hidden",
            this.visibilityChange = "visibilitychange") : "undefined" != typeof document.mozHidden ? (hidden = "mozHidden",
            this.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (hidden = "msHidden",
            this.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden",
            this.visibilityChange = "webkitvisibilitychange");

        //var that = this;
        document.addEventListener(this.visibilityChange, function () {
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
            //!document[hidden] && !that._isMuted ? Howler.volume(1) : Howler.volume(0);
            //console.log('sound updated' + that._isMuted);
        }, false);
    }

    get isMute() {
        return this._isMute;
    }

    /**
     * @param {!Array.<string>} sounds
     * @param {!Array.<string>} extensions
     * @param {string=} basePath
     */
    addSounds(sounds, extensions, basePath) {
        basePath = basePath || "";

        let howl, name, url, urls, extension, i, j;
        for (i = 0; i < sounds.length; ++i) {
            url = basePath + sounds[i];
            url = url.split("/");
            name = url[url.length - 1];

            urls = [];
            for (j = 0; j < extensions.length; ++j) {
                extension = extensions[j];
                urls.push(url.join("/") + extension);
            }
            howl = new Howl({
                src: urls,
                volume: 1.0,
                loop: false,
                autoplay: false,
                onloaderror: function () {
                    console.warn("Error loading sound - " + name);
                }
            });
            howl.name = name;
            this._cache[name] = howl;
        }
    }

    /**
     * @param {!Array.<string>} sounds
     */
    removeSounds(sounds) {
        var name, n, howl;
        for (var i = 0; i < sounds.length; ++i) {
            name = sounds[i];
            for (n in this._cache) {
                if (this._cache.hasOwnProperty(key)) {
                    howl = this._cache[key];
                    if (howl.name == n) {
                        howl.unload();
                        delete this._cache[name];
                        break;
                    }
                }
            }
        }
    }

    /**
     * @param {!string | Array.<string>} name
     * @param {AudioParams=} params
     */
    playSound(name, params) {
        params = params || new AudioParams();

        if (typeof name !== "string") {
            name = name[Math.floor(Math.random() * name.length)];
        }

        var howl = this._cache[name];
        if (!howl) {
            console.warn("could not find sound : " + name);
            return null;
        }

        howl.volume(params.volume);
        howl.loop(params.loop);

        // todo sound callback

        if (p3.Device && p3.Device.isAndroidStockBrowser) {
            howl.buffer = true;
        }

        if (params.fadeIn > 0.0) {
            this.fadeIn(howl, params.fadeIn);
        } else {
            howl.play();
        }
        return howl;
    }

    playMusic(name, params) {
        params = params || new AudioParams();

        if (typeof name !== "string") {
            name = name[Math.floor(Math.random() * name.length)];
        }

        // skip if no change
        if (this._music && this._music.name == name) {
            return this._music;
        }

        var howl = this._cache[name];
        if (!howl) {
            console.warn("Could not find music - " + name);
            return null;
        }

        howl.volume(params.volume);
        howl.loop(true);

        // callback
        howl.__onend = function () {
            params.callback && params.callback.call(params.scope);
        };
        howl.on("end", howl.__onend);

        if (p3.Device && p3.Device.isAndroidStockBrowser) {
            howl.buffer = true;
        }

        if (params.fadeIn > 0.0) {
            if (this._music && this._music.name != name) {
                this.fadeOut(this._music, params.fadeIn, function (howl) {
                    howl.stop();
                }, this);
            }
            this.fadeIn(howl, params.fadeIn);
        } else {
            this._music && this.stopMusic();
            howl.play();
        }
        this._music = howl;
        return howl;
    }

    /**
     * @param {!string} name
     */
    stopSound(name) {
        var howl;
        for (var n in this._cache) {
            if (this._cache.hasOwnProperty(n)) {
                howl = this._cache[n];
                if (howl.name == name) {
                    howl.stop();
                    break;
                }
            }
        }
    }

    /**
     *
     * @param name
     */
    stopMusic(name) {
        name = name || this._music.name;
        if (this._music && this._music.name == name) {
            this._music.__onend && this._music.off("end", this._music.__onend);
            this._music.stop();
            this._music = null;
        }
    }

    mute(value) {
        this._isMuted = value;
        if (this._isMuted) {
            Howler.mute(true);
        } else {
            Howler.mute(false);
        }
    }

    /**
     *
     * @param howl
     * @param duration
     * @param callback
     * @param scope
     */
    fadeIn(howl, duration, callback, scope) {
        duration = duration || 1.0;
        howl.volume(0.0);
        howl.play();
        howl.__volume = howl._volume;

        TweenMax.killTweensOf(howl);
        TweenMax.to(howl, duration, {
            __volume: 1.0,
            ease: Power1.easeInOut,
            onUpdate: function () {
                howl.volume(howl.__volume);
            },
            onUpdateScope: this,
            onComplete: callback,
            onCompleteParams: [howl],
            onCompleteScope: scope
        });
    }

    fadeOut(howl, duration, callback, scope) {
        duration = duration || 1.0;
        howl.__volume = howl._volume;

        TweenMax.killTweensOf(howl);
        TweenMax.to(howl, duration, {
            __volume: 0.0,
            ease: Power1.easeInOut,
            onUpdate: function () {
                howl.volume(howl.__volume);
            },
            onUpdateScope: this,
            onComplete: callback,
            onCompleteParams: [howl],
            onCompleteScope: scope
        });
    }
}
